import { render } from "./Rating.vue?vue&type=template&id=cafc60fa"
import script from "./Rating.vue?vue&type=script&setup=true&lang=js"
export * from "./Rating.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/TableFields/Rating.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cafc60fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cafc60fa', __exports__)) {
    api.reload('cafc60fa', __exports__)
  }
  
  module.hot.accept("./Rating.vue?vue&type=template&id=cafc60fa", () => {
    api.rerender('cafc60fa', render)
  })

}


export default __exports__